import { BridgingLoanDTO } from '../Interface/Response/Interest/BridgingLoanDTO';
import { Cell, HeaderCell, InterestTableDTO, Row } from '../Interface/Hook/Interest/InterestTableDTO';
import { Label } from '../Interface/Response/Interest/Label';
import { CellDecorator } from '../Enum/TableDecorator';
import { ExtraInterestProperties, ExtraInterestTypes } from '../Enum/Interest/ExtraInterestProperties';
import { hasValue } from '../Helpers/Interest/InterestHelper';

const makeByProperty = (extraInterestDTO: BridgingLoanDTO, property: ExtraInterestProperties): Cell => {
    if (!(property in extraInterestDTO.extraInterest)) {
        return { value: '', decorator: CellDecorator.Interest };
    }

    return {
        value: extraInterestDTO.extraInterest[property],
        decorator: CellDecorator.Interest,
    };
}

const reduceBridgingLoanTableData = (
    extraInterestDTOs: BridgingLoanDTO[],
    allLabels: Label[],
    hideEmpty: boolean,
): InterestTableDTO => {
    const headers: HeaderCell[] = [
        {
            value: '',
            prop: 'company',
        },
        {
            value: 'Product',
            prop: 'product',
            sortable: true,
        },
        {
            value: ExtraInterestTypes.FIXED,
            prop: ExtraInterestProperties.BRIDGING_LOAN_FIXED,
            className: 'fixed-width',
            sortable: true,
        },
        {
            value: ExtraInterestTypes.VARIABLE,
            prop: ExtraInterestProperties.BRIDGING_LOAN_VARIABLE,
            className: 'fixed-width',
            sortable: true,
        },
    ];

    const properties = [ExtraInterestProperties.BRIDGING_LOAN_FIXED, ExtraInterestProperties.BRIDGING_LOAN_VARIABLE];

    const data: Row[] = extraInterestDTOs.reduce((rows: Row[], curValue) => {
        const label = allLabels.find(({ findataCode }) => findataCode === curValue.finDataCode);
        if (label === undefined) {
            return rows;
        }

        if (hideEmpty && !properties.some(property => hasValue(curValue.extraInterest[property]))) {
            return rows;
        }

        const cells: Cell[] = [
            { value: curValue.finDataCode, decorator: CellDecorator.CompanyIcon },
            { value: label.label },
            makeByProperty(curValue, ExtraInterestProperties.BRIDGING_LOAN_FIXED),
            makeByProperty(curValue, ExtraInterestProperties.BRIDGING_LOAN_VARIABLE),
        ];

        rows.push({ cells });
        return rows;
    }, []);

    return { data, headers };
}

export default reduceBridgingLoanTableData;
